module.exports = __webpack_public_path__ + "static/media/account-blocked.02de7356.png";